import { getElementExists } from "../helper/helper";

export function initJobSelect() {
  const jobSelects = document.querySelectorAll(".job-list");

  if (jobSelects != null && jobSelects != "undefined") {
    // get all Jobs
    jQuery.ajax({
      type: "POST",
      url: globalvars.ajaxurl,
      data: {
        action: "get_all_jobs_ajaxhandler",
        nonce: globalvars.ajax_nonce,
      },
      beforeSend: function () {},
      complete: function () {},
      success: function (response) {
        // console.log(response);
        for (let o = 0; o < jobSelects.length; o++) {
          jobSelects[o].insertAdjacentHTML("beforeend", JSON.parse(response));
        }
      },
      error: function (MLHttpRequest, textStatus, errorThrown) {
        console.log(textStatus, errorThrown);
      },
    });
  }
}
